import { render, staticRenderFns } from "./DrilldownOptions.vue?vue&type=template&id=f0a54050&scoped=true"
import script from "./DrilldownOptions.vue?vue&type=script&lang=js"
export * from "./DrilldownOptions.vue?vue&type=script&lang=js"
import style0 from "./DrilldownOptions.vue?vue&type=style&index=0&id=f0a54050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a54050",
  null
  
)

export default component.exports